import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nlTranslation from './i18n/nl.json';
import enTranslation from './i18n/en.json';

/**
 * i18n configuratie voor de applicatie
 * 
 * Features:
 * - Nederlandse taal als standaard
 * - Engelse taal beschikbaar
 * - Fallback naar Nederlands bij ontbrekende vertalingen
 * - Debug mode in development omgeving
 * - XSS bescherming via React
 * - Taal opslaan in localStorage
 */
i18n
    .use(initReactI18next)
    .init({
        resources: {
            nl: {
                translation: nlTranslation
            },
            en: {
                translation: enTranslation
            }
        },
        lng: localStorage.getItem('language') || 'nl', // Standaard taal of opgeslagen voorkeur
        fallbackLng: 'nl',
        interpolation: {
            escapeValue: false // React doet al XSS escaping
        },
        debug: process.env.NODE_ENV === 'development', // Alleen debug in development
        react: {
            useSuspense: false // Voorkomt problemen met React 18
        }
    });

// Functie om taal te wijzigen
export const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
};

// Functie om huidige taal op te halen
export const getCurrentLanguage = () => {
    return i18n.language;
};

// Functie om beschikbare talen op te halen
export const getAvailableLanguages = () => {
    return [
        { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
        { code: 'en', name: 'English', flag: '🇬🇧' }
    ];
};

export default i18n; 